import React from "react";

const NoZoomWrapper = ({ children }) => {
  const handleTouchStart = (e) => {
    if (e.touches.length > 1) {
      e.preventDefault(); // Pinch zoom block
    }
  };

  const handleDoubleClick = (e) => {
    e.preventDefault(); // Double-tap zoom block
  };

  return (
    <div
      style={{ touchAction: "manipulation" }} // Prevent double-tap zoom in many browsers
      onTouchStart={handleTouchStart}
      onDoubleClick={handleDoubleClick}
    >
      {children}
    </div>
  );
};

export default NoZoomWrapper;
